export const getFavouriteListingIds = currentUser => {
  const ids = currentUser?.attributes?.profile?.privateData?.favouriteListingIds;
  return Array.isArray(ids) ? [...new Set(ids.filter(Boolean))] : [];
};

export const isListingFavourite = (favouriteListingIds, listingId) => {
  return Array.isArray(favouriteListingIds) && !!listingId
    ? favouriteListingIds.includes(listingId)
    : false;
};

export const toggleFavouriteListingId = (favouriteListingIds, listingId) => {
  const ids = Array.isArray(favouriteListingIds)
    ? [...new Set(favouriteListingIds.filter(Boolean))]
    : [];

  if (!listingId) {
    return ids;
  }

  return ids.includes(listingId) ? ids.filter(id => id !== listingId) : [...ids, listingId];
};
